/**
 * Opens a URL and attempts to notify the extension to open the ToDo panel.
 * The extension message has a 1-second timeout to prevent blocking.
 *
 * @param {Object} options - The options object
 * @param {string} options.url - The URL to open
 * @param {string} options.extensionId - The extension ID
 * @param {string} options.todoExtensionVersion - The todo extension version
 * @returns {Promise<void>}
 */
export const openExtensionFromTodo = async ({
  url,
  extensionId,
  todoExtensionVersion,
}) => {
  try {
    if (extensionId && todoExtensionVersion === "inExtension") {
      await Promise.race([
        chrome.runtime.sendMessage(extensionId, {
          type: "openToDoPanel",
        }),
        new Promise((resolve) => setTimeout(resolve, 1000)),
      ]);
    }
  } catch (error) {
    console.error("Error sending message to extension:", error);
  } finally {
    window.open(url, "_blank");
  }
};
